/* Exact Marketplace codes only. Ordinary searches remain owned by Empire.
   The existing /t/ redirect owns exact-variant selection and campaign attribution. */
(function () {
  const normalizeCode = value => {
    const code = String(value || '').trim().toUpperCase();
    return /^T\d{5,}$/.test(code) ? code : null;
  };

  const makeIndex = payload => {
    const index = new Map();
    if (!payload || payload.complete !== true || !Array.isArray(payload.entries)) return index;
    payload.entries.forEach(entry => {
      const code = entry && normalizeCode(entry.code);
      if (!code || typeof entry.label !== 'string') return;
      // Duplicate codes are ambiguous: leave them to normal search instead of guessing.
      index.set(code, index.has(code) ? null : { label: entry.label, url: '/t/' + code.toLowerCase() });
    });
    return index;
  };

  const init = (win, doc, config) => {
    const searchPath = new URL(config.dataset.searchUrl, win.location.origin).pathname.replace(/\/$/, '');
    const endpoint = new URL(config.dataset.indexUrl, win.location.origin);
    // Keep an explicit unpublished-theme preview on that same theme.
    const preview = new URL(win.location.href).searchParams.get('preview_theme_id');
    if (preview) endpoint.searchParams.set('preview_theme_id', preview);
    let indexPromise;
    const getIndex = () => {
      if (!indexPromise) {
        const controller = new win.AbortController();
        const timeout = win.setTimeout(() => controller.abort(), 4000);
        indexPromise = win.fetch(endpoint.href, { signal: controller.signal, credentials: 'same-origin' })
          .then(response => {
            if (!response.ok) throw new Error('Code index unavailable');
            return response.text();
          })
          .then(html => {
            const node = new win.DOMParser().parseFromString(html, 'text/html').querySelector('[data-aw-tire-code-index]');
            return makeIndex(JSON.parse(node.textContent));
          })
          .catch(() => new Map())
          .finally(() => win.clearTimeout(timeout));
      }
      return indexPromise;
    };
    const searchForm = target => {
      const form = target && target.closest('form');
      if (!form || !form.querySelector('input[name="q"]')) return null;
      const action = new URL(form.action, win.location.origin);
      return action.origin === win.location.origin && action.pathname.replace(/\/$/, '') === searchPath ? form : null;
    };
    const suggestionVersions = new WeakMap();
    let interaction = 0;
    const clearSuggestion = form => {
      suggestionVersions.set(form, (suggestionVersions.get(form) || 0) + 1);
      form.removeAttribute('data-aw-tire-code-match');
      const result = form.querySelector('[data-aw-tire-code-result]');
      if (result) result.hidden = true;
    };
    const suggest = async event => {
      const input = event.target;
      const form = searchForm(input);
      if (!form || !input.matches('input[name="q"]')) return;
      if (event.type === 'input' || event.type === 'change') interaction++;
      clearSuggestion(form);
      const version = suggestionVersions.get(form);
      const code = normalizeCode(input.value);
      if (!code) return;
      const match = (await getIndex()).get(code);
      if (!match || suggestionVersions.get(form) !== version || normalizeCode(input.value) !== code || doc.activeElement !== input) return;
      let result = form.querySelector('[data-aw-tire-code-result]');
      if (!result) {
        result = doc.createElement('div');
        result.className = 'aw-tire-code-search-result';
        result.setAttribute('data-aw-tire-code-result', '');
        result.setAttribute('role', 'status');
        form.appendChild(result);
      }
      const link = doc.createElement('a');
      link.href = match.url;
      link.textContent = 'Open ' + code + ' — ' + match.label;
      result.replaceChildren(link);
      result.hidden = false;
      form.setAttribute('data-aw-tire-code-match', '');
    };
    doc.addEventListener('input', suggest);
    doc.addEventListener('change', suggest);
    doc.addEventListener('focusin', event => {
      doc.querySelectorAll('[data-aw-tire-code-match]').forEach(form => {
        if (!form.contains(event.target)) clearSuggestion(form);
      });
      suggest(event);
    });
    doc.addEventListener('focusout', event => {
      const form = searchForm(event.target);
      if (form && !form.contains(event.relatedTarget)) clearSuggestion(form);
    });
    doc.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const form = searchForm(event.target);
        if (form) { interaction++; clearSuggestion(form); }
      }
    });
    doc.addEventListener('reset', event => {
      const form = searchForm(event.target);
      if (form) { interaction++; clearSuggestion(form); }
    });
    doc.addEventListener('click', event => {
      doc.querySelectorAll('[data-aw-tire-code-match]').forEach(form => {
        if (!form.contains(event.target)) clearSuggestion(form);
      });
    });

    const bypass = new WeakSet();
    let submission = 0;
    doc.addEventListener('submit', async event => {
      const form = searchForm(event.target);
      if (!form) return;
      if (bypass.has(form)) { bypass.delete(form); return; }
      const request = ++submission;
      const input = form.querySelector('input[name="q"]');
      const code = normalizeCode(input.value);
      if (!code) return;
      // Empire clones and submits its form: intercept before its target listener runs.
      event.preventDefault();
      event.stopImmediatePropagation();
      const match = (await getIndex()).get(code);
      if (request !== submission || normalizeCode(input.value) !== code) return;
      if (match) {
        win.location.assign(match.url);
      } else {
        bypass.add(form);
        form.requestSubmit();
      }
    }, true);

    const current = new URL(win.location.href);
    if (current.pathname.replace(/\/$/, '') === searchPath) {
      const code = normalizeCode(current.searchParams.get('q'));
      if (code) getIndex().then(index => {
        const match = index.get(code);
        if (match && submission === 0 && interaction === 0 && win.location.href === current.href) win.location.replace(match.url);
      });
    }
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = { normalizeCode, makeIndex, init };
  if (typeof document !== 'undefined') {
    const config = document.querySelector('[data-aw-tire-code-search]');
    if (config) init(window, document, config);
  }
})();
